import Modal from "components/atoms/modal";
import { H4, TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onCloseModal: () => void;
}

// 샘플 신청 성공 시
const ModalContactComplete = ({ onCloseModal }: Props) => {
  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <H4 className="mb-3">샘플 요청 완료</H4>
      <TextSm className="text-black-60% mb-5">
        샘플 요청이 완료되었습니다. 요청사항은 2~3 영업일 내로 처리 될
        예정입니다.
      </TextSm>
      <Btn.Blue onClick={onCloseModal} size="large" className="w-full">
        확인
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalContactComplete;
